module.exports = __webpack_public_path__ + "static/media/conversation.14f71a36.png";